import styled from 'styled-components';
import { cssWhiteSection } from 'components/base/common-styles';
import { getColor } from 'common/constants/_colors';
import { StyledRowHeader } from '../../../ProjectProgression.style';

export const StyledHeader = styled(StyledRowHeader)`
  display: flex;
  align-items: center;
  color: ${getColor('shark')};
`;

export const StyledSubHeader = styled.header`
  text-transform: uppercase;
  font-weight: 500;
  font-size: 1.3rem;
  margin-top: 3rem;
`;

export const StyledConfigRow = styled.div`
  margin: 1rem 0rem;
  color: ${getColor('shuttleGray')};
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  ${({ bold }) =>
    bold &&
    `
    font-weight: bold
  `};
`;

export const StyledMain = styled.main`
  margin 2rem 1rem;
`;
export const StyledFooter = styled.footer`
  margin-top: 4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledInsightsConfig = styled.div`
  ${cssWhiteSection};
`;
